import Image from 'next/image';
export default function DualFeature({ block, position }) {
  const {
    title,
    description,
    background_color,
    text_color,
    features,
    _metadata
  } = block;

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="editorial-dual-feature"
      className={`px-5 pt-15 pb-15 sm:px-15 sm:pt-20 sm:pb-20 lg:px-[120px] lg:pb-[120px] bg-[${background_color}] text-[${text_color}]`}
    >
      <div className="mx-auto max-w-[1320px]">
        {(title || description) && (
          <div className="mx-auto text-center">
            {title && <h2 className="h4 sm:h3 lg:h2">{title}</h2>}
            {description && (
              <p className="body-r sm:body-l lg:sh8 mx-auto mt-4 max-w-[790px]">
                {description}
              </p>
            )}
          </div>
        )}
        {features.length > 0 && (
          <div className="mt-0 sm:mt-15 sm:flex">
            {features.map((feature, index) => {
              return (
                <div
                  key={index}
                  className={`${index == 0 ? 'sm:mr-5' : 'sm:ml-5'} mt-8 sm:mt-0 sm:w-1/2`}
                >
                  <Image
                    src={feature.image.url}
                    alt={feature.image.title.replace(/\.[^/.]+$/, '')}
                    width="640"
                    height="360"
                    sizes="(min-width: 1536px) 640px, (min-width: 1280px) 494px, (min-width: 1024px) 365px, (min-width: 768px) 297px, (min-width: 640px) 233px, 585px"
                    className="mb-4"
                  />
                  <h3 className="sh10 sm:sh9 mb-2">{feature.title}</h3>

                  {feature?.description && (
                    <div
                      className="body-r rte-simple"
                      dangerouslySetInnerHTML={{ __html: feature.description }}
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
